"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultCodec = void 0;
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/no-explicit-any */
const t = __importStar(require("io-ts"));
/**
 *  Creates a default value for an io-ts codec.
 * @param codec - the codec whose default we want to create
 * @returns an object honoring the io-ts codec
 *
 * Use Case: CSV Generation from Typed Objects
 * Consider the following codec:
 *
 * const UserCodec = t.intersection([
 *  t.type({
 *    id: t.string,
 *    name: t.string,
 *  }),
 *  t.partial({
 *    email: t.string,
 *  })
 * ])
 *
 * Suppose we want to generate a CSV file from the objects below with UserCodec type:
 *
 * const users = [
 *   { id: '1', name: 'Alice', email: 'alice@email.com' },
 *   { id: '2', name: 'Bob' },
 * ]
 *
 * To generate a CSV, we need a consistent set of columns (headers) that includes
 * ALL possible fields, even if some objects don't have all properties. In the example
 * above, though, notice that the second user does not have the email property.
 *
 * In such a case, createDefaultCodec(UserCodec) is useful to construct an object
 * with all possible fields, which can then be used to generate the complete CSV header:
 * "id,name,email".
 *
 * The example above is pretty simple, but things get very compliated the more complex
 * is the codec. In any case, createDefaultCodec is useful for outputting the expected CSV header.
 */
const createDefaultCodec = (codec) => {
    // If the codec is an union
    if (codec instanceof t.UnionType) {
        // The default for a union containing arrays is a default array
        const arrayType = codec.types.find((type) => type instanceof t.ArrayType);
        if (arrayType) {
            return (0, exports.createDefaultCodec)(arrayType);
        }
        // If the union does not have an array, but have objects, the default is the object
        const objectType = codec.types.find((type) => type instanceof t.InterfaceType ||
            type instanceof t.PartialType ||
            type instanceof t.IntersectionType ||
            type instanceof t.ArrayType);
        if (objectType) {
            return (0, exports.createDefaultCodec)(objectType);
        }
        // Otherwise, null is next in priority
        const hasNull = codec.types.some((type) => type instanceof t.NullType || type.name === 'null');
        if (hasNull) {
            return null;
        }
        // If no null type found, default to first type
        return (0, exports.createDefaultCodec)(codec.types[0]);
    }
    // The default of an interface or partial type, is an object with that interface or partial type
    if (codec instanceof t.InterfaceType || codec instanceof t.PartialType) {
        const defaults = {};
        Object.entries(codec.props).forEach(([key, type]) => {
            defaults[key] = (0, exports.createDefaultCodec)(type);
        });
        return defaults;
    }
    // The default of an intersection, is the merged defaults of the intersection values
    if (codec instanceof t.IntersectionType) {
        return codec.types.reduce((acc, type) => ({
            ...acc,
            ...(0, exports.createDefaultCodec)(type),
        }), {});
    }
    /**
     * The default of an Array is an empty array, unless it is an array of objects, in which
     * case the default is an array of one default object.
     */
    if (codec instanceof t.ArrayType) {
        const elementType = codec.type;
        const isObjectType = elementType instanceof t.InterfaceType ||
            elementType instanceof t.PartialType ||
            elementType instanceof t.IntersectionType;
        return (isObjectType ? [(0, exports.createDefaultCodec)(elementType)] : []);
    }
    // The default of a literal type is its value
    if (codec instanceof t.LiteralType) {
        return codec.value;
    }
    // The default of an object type is an empty object
    if (codec instanceof t.ObjectType) {
        return {};
    }
    // Handle primitive and common types
    switch (codec.name) {
        case 'string':
            return '';
        case 'number':
            return 0;
        case 'boolean':
            return false;
        case 'null':
            return null;
        case 'undefined':
            return undefined;
        default:
            return null;
    }
};
exports.createDefaultCodec = createDefaultCodec;
//# sourceMappingURL=createDefaultCodec.js.map